document.addEventListener('DOMContentLoaded', () => {
    let searchBars = document.querySelectorAll('.search-trigger');
    let resultsWrapper = document.querySelector('.predictive-search')
    let resultsContainer = resultsWrapper.querySelector('.inner');
    let resultsModal = resultsWrapper.querySelector('.predictive-search-modal');

    searchBars.forEach(searchBar => {
    
        // Site search using predictive search api
        const predictiveSearchCallBack = () => { 
            const section_name = 'gt-predictive-search';

            if(searchBar.value.length > 2){
                
                var requestResponse;
                fetch(`${window.Shopify.routes.root}search/suggest?q=${searchBar.value}&resources[type]=product,collection,article,page&resources[options][fields]=title,product_type,variants.title,tag&resources[limit_scope]=each&section_id=${section_name}`)
                .then((response) => {
                    requestResponse = response;
                    return response.text();
                })
                .then((text) => {
                    if (!requestResponse.ok) {
                    throw new Error(`${requestResponse.status}: ${text}`);
                    }
                    resultsWrapper.classList.add('active');

                    const resultsMarkup = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector(`#shopify-section-${section_name}`).innerHTML;

                    resultsContainer.innerHTML = resultsMarkup;
                    applyHeight();
            
                })
                .then (() => {
                    let resultsButton = document.querySelectorAll('.results-button');
                    if(resultsButton){
                        resultsButton.forEach(button => {
                            button.href = `/search?q=${searchBar.value}&type=product`;
                        });
                    }
                    document.addEventListener('keyup', (event) => {
                        if (event.key === 'Escape') {
                            resultsWrapper.classList.remove('active');
                        } else if (event.key === 'Enter') {
                            window.location.href = `/search?q=${searchBar.value}`;
                        }
                    })
                })
                .then (() => {
                    setTimeout(() => {
                        window.globalListeners.hideEmptyCardReview();
                    }, 500);
                    
                })
                .catch((error) => {
                    console.error(error);
                });
            } else {
                resultsContainer.innerHTML = '';
                resultsWrapper.classList.remove('active');
            }
        }
    
        let searchMethod = predictiveSearchCallBack;

        if(searchBar && resultsContainer){
            searchBar.addEventListener('keyup', searchMethod)
            let closeButton = resultsWrapper.querySelector('.close');
            closeButton.addEventListener('click', () => {
                resultsWrapper.classList.remove('active');
            })   
        }
    }) 

    function handleScroll() {
        var scrollThreshold = 0;
        
        if (window.scrollY > scrollThreshold & !resultsModal.classList.contains('scrolled')) {
            resultsModal.classList.add('scrolled');
         
        } else if (window.scrollY == scrollThreshold) {
            resultsModal.classList.remove('scrolled');
         
        }
    }
    function handleClickOutside(event) {

        if (!resultsContainer.contains(event.target)) {
            resultsWrapper.classList.remove('active');
        }
    }

    document.addEventListener('click', handleClickOutside);
    window.addEventListener('scroll', handleScroll);

    const applyHeight = () => {
        const searchSidebar = resultsContainer.querySelector('.search-sidebar');
        const blockLink = resultsContainer.querySelector('.block-link');
        const height = resultsContainer.offsetHeight;
        if (window.innerWidth > 768) {
            if (searchSidebar) {
                searchSidebar.style.height = `${height - 60}px`;
            }
            if (blockLink) {
                blockLink.style.paddingTop = `${height - 60}px`;
            }
        } else {
            if (searchSidebar) {
                searchSidebar.style.height = '';
            }
            if (blockLink) {
                blockLink.style.paddingTop = '';
            }
        }
    };
    
    window.addEventListener('resize', applyHeight);
})


